import { useQuery } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

// Full detail for whichever version is selected on the payer detail page —
// works for proposed/superseded versions too, not just the active one.
export function useMapVersionDetail(versionId: string | null) {
  const query = useQuery({
    queryKey: payerKeys.versionDetail(versionId ?? ''),
    queryFn: () => payersApi.getMapVersion(versionId as string),
    enabled: !!versionId,
  });
  return { version: query.data ?? null, isLoading: query.isLoading };
}
